<template>
  <svg
    class="fill-none"
    viewBox="0 0 66 66"
  >
    <circle
      class="stroke-black stroke-2"
      cx="33"
      cy="33"
      r="32"
    />
    <path
      class="fill-black"
      d="M17.9732 48.9107C17.2661 48.9107 16.6473 48.6455 16.1169 48.1152C15.5866 47.5848 15.3214 46.9661 15.3214 46.2589V29.8621H17.9732V46.2589H37.95V48.9107H17.9732ZM23.321 43.6072C22.6138 43.6072 21.9877 43.342 21.4426 42.8116C20.8975 42.2813 20.625 41.6625 20.625 40.9554V24.5585H23.2768V40.9554H43.2978V43.6072H23.321ZM28.5803 38.3036C27.8732 38.3036 27.2544 38.0384 26.7241 37.508C26.1937 36.9777 25.9286 36.3589 25.9286 35.6518V19.7411C25.9286 19.0339 26.1937 18.4152 26.7241 17.8848C27.2544 17.3545 27.8732 17.0893 28.5803 17.0893H48.0268C48.7339 17.0893 49.3527 17.3545 49.883 17.8848C50.4134 18.4152 50.6786 19.0339 50.6786 19.7411V35.6518C50.6786 36.3589 50.4134 36.9777 49.883 37.508C49.3527 38.0384 48.7339 38.3036 48.0268 38.3036H28.5803ZM28.5803 35.6518H48.0268V22.4813H28.5803V35.6518Z"
    />
    <g
      v-if="showPadlock"
      data-test="padlock"
    >
      <circle
        class="fill-danger stroke-black"
        cx="53.5"
        cy="12.5"
        r="12"
      />
      <path
        class="fill-white"
        d="M50.375 17.5C50.0886 17.5 49.8434 17.399 49.6394 17.1969C49.4354 16.9949 49.3334 16.752 49.3334 16.4683V11.3095C49.3334 11.0258 49.4354 10.7829 49.6394 10.5809C49.8434 10.3788 50.0886 10.2778 50.375 10.2778H50.8959V9.24605C50.8959 8.53243 51.1498 7.92413 51.6576 7.42115C52.1654 6.91818 52.7796 6.66669 53.5 6.66669C54.2205 6.66669 54.8347 6.91818 55.3425 7.42115C55.8503 7.92413 56.1042 8.53243 56.1042 9.24605V10.2778H56.625C56.9115 10.2778 57.1567 10.3788 57.3607 10.5809C57.5647 10.7829 57.6667 11.0258 57.6667 11.3095V16.4683C57.6667 16.752 57.5647 16.9949 57.3607 17.1969C57.1567 17.399 56.9115 17.5 56.625 17.5H50.375ZM53.5 14.9207C53.7865 14.9207 54.0317 14.8196 54.2357 14.6176C54.4397 14.4155 54.5417 14.1726 54.5417 13.8889C54.5417 13.6052 54.4397 13.3623 54.2357 13.1602C54.0317 12.9582 53.7865 12.8572 53.5 12.8572C53.2136 12.8572 52.9684 12.9582 52.7644 13.1602C52.5604 13.3623 52.4584 13.6052 52.4584 13.8889C52.4584 14.1726 52.5604 14.4155 52.7644 14.6176C52.9684 14.8196 53.2136 14.9207 53.5 14.9207ZM51.9375 10.2778H55.0625V9.24605C55.0625 8.81616 54.9106 8.45075 54.6068 8.14982C54.303 7.8489 53.9341 7.69843 53.5 7.69843C53.066 7.69843 52.6971 7.8489 52.3933 8.14982C52.0895 8.45075 51.9375 8.81616 51.9375 9.24605V10.2778Z"
      />
    </g>
  </svg>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BulkSendCircleIcon',
  props: {
    showPadlock: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
</script>
